import { useQuery } from '@tanstack/react-query';
import { fetchUrl } from '@utils/api';

/**
 * Fetches a presigned URL for an S3-stored thumbnail via the file service.
 *
 * @param {string|null|undefined} path - The S3 key (e.g. "taxonomy-thumbnails/images/spruce.jpg").
 * @returns {string|null} The resolved signed URL, or null while loading / if unavailable.
 */
export const useThumbnailUrl = path => {
	const { data } = useQuery({
		queryKey: ['thumbnail', path],
		queryFn: () => fetchUrl(`filelink?key=${path}`),
		enabled: Boolean(path),
		staleTime: 1000 * 60 * 30, // presigned URLs are typically valid ~1 hour
	});

	return data?.url ?? null;
};
